var render = function render(){var _vm=this,_c=_vm._self._c;return _c('duo-agents-platform-index',{attrs:{"is-loading-workflows":_vm.isLoadingWorkflows,"workflows":_vm.workflows,"workflows-page-info":_vm.workflowsPageInfo,"workflow-query":_vm.$apollo.queries.workflows}})
}
var staticRenderFns = []

export { render, staticRenderFns }